import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteMetricsSurfaceProps = {
  className?: string | undefined;
  children?: React.ReactNode | undefined;
};

/**
 * A container element used to render the Project Metrics surface. This component
 * will take care of styling your component so it looks good as a section
 * rendered under the metrics navigation for projects in the Netlify UI.
 *
 * <!-- TODO(calebbarnes): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteMetrics
 * @example
 * ```tsx
 * import { SiteMetricsSurface } from "@netlify/sdk/react/components";
 *
 * <SiteMetricsSurface>
 *   <div>Your surface content goes here</div>
 * </SiteMetricsSurface>
 * ```
 */
export const SiteMetricsSurface = ({
  className,
  children,
  ...otherProps
}: SiteMetricsSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteMetrics}-${sdk.extension.slug}`}
      className={className}
      {...otherProps}
    >
      {children}
    </section>
  );
};
